import { useEffect } from "react";
import { useAuth } from "@shared/contexts/auth-context";
import { useBalanceWebSocket } from "@shared/hooks/useBalanceWebSocket";

/**
 * Провайдер для WebSocket подключения баланса
 * Автоматически подключается когда пользователь авторизован
 */
// eslint-disable-next-line react/prop-types
export const BalanceWebSocketProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const { connect, disconnect } = useBalanceWebSocket();

  useEffect(() => {
    if (isAuthenticated) {
      // Подключаемся к WebSocket когда пользователь авторизован
      connect();
    } else {
      // Отключаемся когда пользователь вышел
      disconnect();
    }
  }, [isAuthenticated, connect, disconnect]);

  return <>{children}</>;
};
